module.exports = __webpack_public_path__ + "img/3.f1021d16.jpg";